import React from 'react';
import {
  contentNotSet,
  contentSet,
  headingNotSet,
  processFootnoteReferences,
} from '../../services/TemplateUtils';
import PropertyCard from '../PropertyCard';
import { CarouselItem, ImageCarouselProps } from './imageCarouselTypes';

interface ImageCarouselItemRowProps {
  item: CarouselItem;
  index: number;
  printMode?: boolean;
  preventImageCrop?: boolean;
  footnotes?: ImageCarouselProps['footnotes'];
  itemsCount: number;
  getVideoPlaybackUrl?: (externalId: string) => Promise<{ url: string }>;
}

export default function ImageCarouselItemRow({
  item,
  index,
  printMode,
  preventImageCrop,
  footnotes,
  itemsCount,
  getVideoPlaybackUrl,
}: ImageCarouselItemRowProps) {
  const processedDescription = item.text?.content
    ? processFootnoteReferences(item.text.content, footnotes)
    : item.text?.content;

  return (
    <PropertyCard
      alwaysHovered={itemsCount === 1 && !item.isVideo}
      address={item.address}
      titlePlaceholder={headingNotSet(item.heading)}
      descriptionPlaceholder={contentNotSet(item.text || null)}
      key={`${index}-${(item.imageUrl || item.videoURL)?.url}`}
      imageUrl={item.imageUrl?.url}
      altText={item.altText?.content}
      linkTo={item.linkTo}
      linkable={item.linkable}
      expandable
      forceTitleSpacing
      printMode={printMode}
      title={contentSet(item.heading) ? item.heading.content : '   '}
      description={contentNotSet(item.text || null) ? undefined : processedDescription}
      isHtmlDescription
      removable={item.removeable}
      onRemove={() => item.onRemove?.()}
      isVideo={!!item.isVideo}
      videoSource={item.videoSource}
      videoURL={item.isVideo ? item.videoURL?.url : undefined}
      libraryVideoExternalId={item.isVideo ? item.libraryVideoExternalId : undefined}
      getVideoPlaybackUrl={getVideoPlaybackUrl}
      preventImageCrop={preventImageCrop}
      customImageRenderer={item.customImageRenderer}
    />
  );
}
